import React from 'react';
import { ActionItem } from '../../gs-component-form';
import { DisplayLink } from '@xo-union/tk-ui-links';
import { Subtle, Body2 } from '@xo-union/tk-ui-typography';
import { EventType } from '../EventTypes';
import styles from './noQuestionsModule.scss';

interface Props {
  privateRsvp: boolean;
  event: EventType | null;
  openQuestionRightRail: (question: null, event: EventType | null) => void;
  openEvent?: (id: any) => void;
  isRsvpRequired?: boolean;
  testId?: string | number;
}

const NoQuestionsModule: React.FC<Props> = ({
  privateRsvp,
  event,
  openEvent,
  openQuestionRightRail,
  isRsvpRequired,
  testId,
}) => {
  const showActionItem = isRsvpRequired;
  const followUpText = 'Add a Follow-Up Question';
  let headerText;
  let bodyText;

  if (event && !isRsvpRequired) {
    headerText = "Toggle on 'Collect RSVPs' if you want to gather a guest count for this event.";
    bodyText = "Don't worry, no one will be able to RSVP until you make this page visible on your Wedding Website.";
  } else if (event && event.guestCount === 0 && privateRsvp && openEvent) {
    headerText = (
      <>
        Heads up! There are <u>0 guests</u> on your{' '}
        <DisplayLink onClick={openEvent} className={styles.displayLink}>
          {event.name}
        </DisplayLink>{' '}
        guest list.
      </>
    );
    bodyText = 'In the meantime, start drafting questions here for when your list is ready.';
  } else if (event && privateRsvp && openEvent) {
    // If there are guests, and RSVP is private
    headerText = 'Need to collect additional guest info?';
    bodyText = (
      <>
        Add questions that all {event.guestCount} guests on your{' '}
        <DisplayLink onClick={openEvent} className={styles.displayLink}>
          {event.name}
        </DisplayLink>{' '}
        list will see when they RSVP &quot;Yes!&quot; on your Website.
      </>
    );
  } else if (event && !privateRsvp) {
    // If no event and RSVP is public.
    headerText = 'Need to collect additional guest info?';
    bodyText = 'Add questions that anyone who RSVPs "Yes!" on your Website will see.';
  } else if (!event) {
    // If no event (for general guest wedding questions)
    headerText = 'Need to collect additional guest info?';
    bodyText = "These questions will be asked to all guests that RSVP, regardless of if they say 'Yes' or 'No'";
  }

  return (
    <div data-testid="noQuestionsModule" className={styles.container}>
      <Subtle className={styles.header}>{headerText}</Subtle>
      <Body2 className={`${styles.subHeader} ${showActionItem && styles.baseBottomMargin}`}>{bodyText}</Body2>
      {showActionItem ? (
        <div data-testid={`${testId}-noQuestionsModule`}>
          <ActionItem type="add" onClick={(): void => openQuestionRightRail(null, event)}>
            {event ? followUpText : 'Add RSVP Question'}
          </ActionItem>
        </div>
      ) : null}
    </div>
  );
};

export default NoQuestionsModule;
